import { render, staticRenderFns } from "./OpenExternalBrowser.vue?vue&type=template&id=5b4f50a2&"
import script from "./OpenExternalBrowser.vue?vue&type=script&lang=ts&"
export * from "./OpenExternalBrowser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports